__turbopack_context__.v({
  "box": "CustomCheckbox-module__z2cTGW__box",
  "disabled": "CustomCheckbox-module__z2cTGW__disabled",
  "icon": "CustomCheckbox-module__z2cTGW__icon",
  "input": "CustomCheckbox-module__z2cTGW__input",
  "label": "CustomCheckbox-module__z2cTGW__label",
});
